import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavArrowIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_6003_13642)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14 1.03338L12.9841 0C12.3249 0.612244 11.5491 1.08538 10.703 1.39117C9.85695 1.69695 8.95792 1.82911 8.05963 1.77975C6.93533 1.79045 5.82065 1.57192 4.78363 1.1375L4.24988 2.7545C5.36249 3.17843 6.54439 3.39119 7.735 3.38188C8.31065 3.38288 8.88503 3.32779 9.45 3.21738L0 12.6464L1.35538 14L10.8054 4.536C10.6958 5.1217 10.6413 5.71638 10.6426 6.31225C10.6289 7.48624 10.8367 8.65228 11.2551 9.74925L12.8861 9.23125C12.4372 8.19851 12.2129 7.08213 12.2281 5.95613C12.1778 5.05865 12.3088 4.16023 12.6132 3.31447C12.9176 2.4687 13.3893 1.69291 14 1.03338Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6003_13642",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgNavArrowIcon;
